import React from 'react';
import classNames from 'classnames';

import ConnectedAuthNotification from '../../connectedComponents/AuthNotification';

import './SplitContainer.scss';

const SplitContainer = ({
    children,
    secondary,
    header,
    shouldShowSecondaryPanel,
    usesNewStyles,
}) => {
    const containerClasses = classNames('split-container', {
        'split-container--new-styles': usesNewStyles,
    });

    return (
        <div className={containerClasses}>
            <div className="split-container__primary">
                <div className="split-container__content">
                    {header && header}

                    <ConnectedAuthNotification />

                    {children}
                </div>
            </div>

            {shouldShowSecondaryPanel && (
                <div className="split-container__secondary">{secondary}</div>
            )}
        </div>
    );
};

export default SplitContainer;
